'use strict';
define([
    'angular',
    'modules/backlink-checker/components/mini-doughnut/mini-doughnut.component'
], function (angular,miniDoughnut) {
    var app = angular.module('app.backlinkchecker.ui', []);
    app.component('miniDoughnut', miniDoughnut);
    return app;
});
